module.exports = __webpack_public_path__ + "img/schedule-main.2a165c7d.png";